export const categoryUrl="/api/categories";
export const videoUrl="/api/videos";
export const loginUrl="/api/auth/login";
export const signupUrl="/api/auth/signup";
export const watchLaterUrl="/api/user/watchlater";
export const historyUrl="/api/user/history";
export const likedUrl="/api/user/likes";
export const playlistUrl="/api/user/playlists";